module.exports = __webpack_public_path__ + "img/225.dde7a72f.jpg";